import { hexToUint8Array, uint8ArrayToHexStr } from '@pactswap/cwap-cm-lib/shared';
export const createL1BtcTxData = (params) => {
    const pactId = hexToUint8Array(params.requestId);
    const results = [pactId.byteLength, ...pactId];
    return new Uint8Array(results);
};
export const parseL1BtcTxData = (hexData) => {
    const uint8Data = hexToUint8Array(hexData);
    let offset = 0;
    const sliceNext = (length) => {
        const slice = uint8Data.slice(offset, (offset += length));
        return slice;
    };
    const sliceNextParam = () => {
        const paramLength = sliceNext(1)[0];
        return uint8ArrayToHexStr(sliceNext(paramLength));
    };
    const result = {};
    result.requestId = sliceNextParam();
    return result;
};
